export enum FileFolderTypeEnum {
  Task = 0,
  Comment = 1,
  Profile = 2,
  Project = 3,
  Icon = 4,
  Chat = 5,
  MessengerTeam = 6,
  MessengerGroup = 7,
  ChatImage = 8,
  SoundNotification = 9,
  WikiPage = 10,
  WikiFolder = 11,
  GlobalStatuses = 12,
}
